import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "task-unchecked",
  "use": "task-unchecked-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"CurrentColor\" viewBox=\"0 0 14 14\" id=\"task-unchecked\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"6.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol